"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getParseInstance() {
    // Permet de forcer l'utilisation de la version Node de Parse
    // cf https://github.com/AmbulizTEAM/ambuliz-core/issues/85
    if (process.env.CORE_PARSE_FORCE_NODE) {
        return require('parse/node');
    }
    // Source: https://stackoverflow.com/questions/39468022/how-do-i-know-if-my-code-is-running-as-react-native
    if (typeof document != 'undefined') {
        return require('parse');
    }
    else if (typeof navigator != 'undefined' && navigator.product == 'ReactNative') {
        return require('parse/react-native');
    }
    else {
        return require('parse/node');
    }
}
const res = {
    ParseInstance: getParseInstance(),
};
exports.default = res;
//# sourceMappingURL=ParseProvider.js.map